import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.modals.data.email_confirmation,
    props.user.user,
    (email_confirmation, user) => {
        return {
            stage: email_confirmation.stage,
            data: email_confirmation[email_confirmation.stage],
            user
        }
    }
)